function forceValue(formValue) {
  if (formValue === null || formValue === undefined) {
    return "";
  }
  return formValue;
}

export default forceValue;
